module.exports = __webpack_public_path__ + "static/media/checkTick.65be416d.svg";